import { stringify } from 'qs'
import Route from 'route-parser'
import { getBaseURI } from '../helpers/document'

const routes = {}

export const register = function (name, route) {
  routes[name] = route
}

export const registerRoute = function (name, route) {
  register(name, new Route(route))
}

export const toQueryString = function (query = {}) {
  const queryString = stringify(query, { arrayFormat: 'repeat' })
  return queryString.length > 0 ? '?' + queryString : ''
}

export default function (name, params = {}, query = {}, isExternal = false) {
  const queryString = toQueryString(query)
  if (isExternal && routes.hasOwnProperty(name)) {
    return getBaseURI() + 'ms/' + routes[name].reverse(params) + queryString
  }
  if (routes.hasOwnProperty(name)) {
    return routes[name].reverse(params) + queryString
  }
  throw new Error(`Route ${name} is undefined`)
}
